<lib-history-tab
  [permissions]="permissions()"
  [workflowName]="''"
  [additionalFilters]="scheduleFilter()" />
